// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

// this function is called on update and delete so adding additional expands once rather than changing 3 other files
export const XngExpandApiParameter: typeof PopulateApiParameter = (props: any) => {
    const ourExpand = ["cartLines", "restrictions", "properties", "validation", "paymentOptions"];
    const state = props.getState();
    const pageType = getCurrentPage(state).type;
    const appSettings = getSettingsCollection(state);
    props.apiParameter.expand = [...new Set([...props.apiParameter.expand, ...ourExpand])];
    const timestamp = `time${new Date().getTime()}`;

    // XNG-Change make sure we expand tax if needed on the minicart.
    if (props.needFullCart) {
        props.apiParameter.expand = [...new Set([...(props.apiParameter.expand || []), "carriers", "costCodes"])];
    } else if (appSettings.cartSettings.showTaxAndShipping) {
        props.apiParameter.expand.push("tax");
    } else {
        props.apiParameter.expand = props.apiParameter.expand.filter((expand: string) => expand !== "shipping");
    }
    // <XNG-Change> remove carriers on the cart page
    if (pageType === "CartPage") {
        props.apiParameter.expand = props.apiParameter.expand.filter((expand: string) => expand !== "carriers");
    }
    // </XNG-Change>
    props.apiParameter.expand?.push(timestamp);
};

addToChainAfter(chain, PopulateApiParameter, XngExpandApiParameter);
